import React from 'react';
// javascipt plugin for creating charts
import Chart from 'chart.js';
// react plugin used to create charts
import { Bar } from 'react-chartjs-2';
// reactstrap components
import { map, toNumber } from 'lodash-es';
import {
  useCustomerGeneralAnalyticsByMonth,
  useGeneralCustomerAnalytics,
  useCustomerGeneralAnalyticsByYear,
} from '../../utils/queries/customerQueries';
import { parseOptions } from 'variables/charts';
import { chartOptions } from 'variables/charts';
import { isFloat } from '../../utils/misc';
import { Spinner } from 'reactstrap';
import { isEmpty } from 'lodash-es';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { seperateNumbersWithCommas } from '../../utils/misc';

Chart.plugins.register(ChartDataLabels);

parseOptions(Chart, chartOptions());

export default function AmountTimeCustomerChart({
  granularity,
  handleBarClick,
}) {
  const { data: dailyData, isLoading, error } = useGeneralCustomerAnalytics();
  const { data: monthlyData } = useCustomerGeneralAnalyticsByMonth();
  const { data: yearlyData } = useCustomerGeneralAnalyticsByYear();

  let data = dailyData;

  if (granularity === 'monthly') {
    data = monthlyData;
  }
  if (granularity === 'yearly') {
    data = yearlyData;
  }
  if (isLoading) {
    <h1>Loading</h1>;
  }
  if (error) {
    <h1>Error</h1>;
  }
  let chartData = {
    options: {
      scales: {
        yAxes: [
          {
            display: false,
          },
        ],
      },
      tooltips: {
        enabled: false,
      },
      layout: {
        padding: {
          top: 50,
        },
      },
      onClick: (evt, ele) => {
        handleBarClick(granularity, data[ele[0]?._index]?.DATE);
      },
    },
    plugins: [ChartDataLabels],
    data: {
      labels: map(data, (row) => {
        return row.DATE;
      }),
      datasets: [
        {
          label: 'Total kWh Charged',
          data: map(data, (row) => {
            return isFloat(toNumber(row.AMOUNT) / 100)
              ? (toNumber(row.AMOUNT) / 100).toFixed(2)
              : toNumber(row.AMOUNT) / 100;
          }),
          maxBarThickness: 10,
          datalabels: {
            font: {
              weight: 400,
              size: '12',
            },
            color: 'black',
            backgroundColor: 'transparent',
            align: 'start',
            anchor: 'end',
            clamp: true,
            offset: -25,
            borderRadius: 5,
            padding: 4,
            opacity: 0.8,
            textAlign: 'center',
            formatter: function (value, context) {
              return `₹ ${seperateNumbersWithCommas(value)}`;
            },
            listeners: {
              click: (context) => {
                handleBarClick(granularity, data[context.dataIndex]?.DATE);
              },
            },
          },
        },
      ],
    },
  };
  if (isEmpty(data)) {
    return <></>;
  }
  return (
    <>
      <div
        style={{
          display: 'flex',
          height: '400px',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {isLoading ? (
          <Spinner style={{ color: '#2675b8' }} />
        ) : error ? (
          'Oops something went wrong'
        ) : isEmpty(data) ? (
          'We dont have any Analytics report'
        ) : (
          <Bar data={chartData.data} options={chartData.options} />
        )}
      </div>
    </>
  );
}
